import { useState } from 'react'
import { Create_Student } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { Single_SchoolClass } from '@graphql/queries'
import { mutate } from 'swr'

const useCreateStudent = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      data,
      Create_Student,
      successMessage ? successMessage : 'Eleven är registrerad.',
      errorMessage
        ? errorMessage
        : 'Något gick fel när eleven skulle registreras.',
      async () => {
        data?.input?.class_ids?.forEach(
          async (id) => await mutate([Single_SchoolClass, id.toString()])
        )
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useCreateStudent }
